{
    "fileHashes": {
        "de": "b577c309da15150969be2e3ddd2c5f30a3ed90e86e9cc736d9fff3513ab4f5f9",
        "en": "aee04c19f20ea229588620f28e93586eed7f19c81b07593e93eaf657c5e9d2e4",
        "es": "e43d8a0e01f4c93544202ff7b51e2a5d42b599d35337d91996c216c1fffe4db1",
        "fr": "fe3b836cd13df41bbf9841c6cc98fd981aa74bf1d16f8feda86f0ecf64f39a2d",
        "hu": "0d737ea45e8825c47aef20ab0f3a453cfec6bf9f032e6e867d9345c53219261f",
        "id": "b6d6eb48f96b5faa7b0e623425a4b838708015b981a7f538ba6c65edb4ed0b7a",
        "it": "8d9f3536cc444d4b1fbc2bbcec510b3e72c1bc9ebbb9e15f9cf35f4ed581c7d0",
        "ja": "7f865246bd777e58bfa4757bc65332884a68d44f756d55d7c6aabc4aba6d82a5",
        "ko": "bc2614a6306a72791ab11a618e9a7a7a4f1e9b819e20b251b8930e48864734f8",
        "nl": "841af446bf8b2bea0839ea680c367d7bbd34101af0bfc96c559c9c3949b560b9",
        "pl": "0b162af4f4fe17c5b7670fa253fee1441562f1b09d60daa4e5a7129d5c4ae344",
        "pt": "54b452eb185b6f7b1670c55ddc3bd6e31e25ebb4319d84a1bcaf788b8c5041dc",
        "th": "d4ca60ba4b857f4b857154c2535c7efcc5974783ba6dcb1854a992f218c6e9da",
        "zh": "94d7188c389b7a25da2dc99941629082ff59fe72d7791fd1dcec9407bfe5d07d",
        "zh_TW": "b9b6b88211a872f164de87956cd2691e49427726fe636a9ef89a4a92eea634d6"
    },
    "lastUpdatedAt": "2026-06-16T10:08:48.928Z"
}
